import { io } from 'socket.io-client';

let socketInstance = null;

export const getSocket = () => {
  if (socketInstance) return socketInstance;
  const token = localStorage.getItem('token');
  if (!token) return null;
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
  const origin = baseUrl.replace(/\/api\/?$/, '');
  socketInstance = io(origin, {
    transports: ['websocket', 'polling'],
    auth: { token },
  });
  return socketInstance;
};

export const disconnectSocket = () => {
  if (!socketInstance) return;
  socketInstance.disconnect();
  socketInstance = null;
};
